import React, {useState, useEffect} from 'react';
import {
    Grid,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Button,
    CircularProgress,
    Box,
    FormControlLabel,
    Checkbox,
} from '@mui/material';
import { toast } from 'react-toastify';
import 'react-date-range/dist/styles.css';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import useApi from '../../../hooks/useApi';
import StatisticsCheckbox from '../../../components/date/StatisticsCheckbox';
import SelectMulti from '../../../components/select/SelectMulti';
import UploadFileDialog from '../components/UploadFileDialog';
import 'react-date-range/dist/theme/default.css';
import {sendDataToApi} from '../../../API/apiHelper';
import KeyboardDoubleArrowDownOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowDownOutlined';
import {getInsertCsvTemplate, fetchInsertBundlesStatisticFields, fetchInsertAdtCompanies} from '../../../API/AdtimizerReport';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import BackupTableOutlinedIcon from '@mui/icons-material/BackupTableOutlined';
import DateRangeSelector from '../../../components/date/DateRangeSelector';
import CreateInsertBundleDialog from './CreateInsertBundleDialog';

function InsertBundlesPanelOptions({ onSubmit }) {
    const {data: statistics, loading: loadingStats} = useApi(fetchInsertBundlesStatisticFields);
    const {data: adtCompanies, loading: loadingAdtCompanies} = useApi(fetchInsertAdtCompanies);
    const {data: templateLink, loading: loadingTemplateLink} = useApi(getInsertCsvTemplate);

    const [loading, setLoading] = useState(false);
    const [openEditCompany, setOpenEditCompany] = useState(false);
    const [showCompanies, setShowCompanies] = useState(false);

    const [openUpload, setOpenUpload] = useState(false);
    const handleCloseUpload = () => setOpenUpload(false);
    const handleClickOpenUpload = () => setOpenUpload(true);

    const [openEditBundle, setOpenEditBundle] = useState(false);

    const [allAdmyCompanies, setAllAdmyCompanies] = useState([]);

    const today = new Date();
    today.setDate(today.getDate() + 1);
    today.setHours(0, 0, 0, 0);

    const twoWeeksAgo = new Date();
    twoWeeksAgo.setDate(twoWeeksAgo.getDate() - 6);
    twoWeeksAgo.setHours(0, 0, 0, 0);

    const [options, setOptions] = useState({
        start_date: twoWeeksAgo,
        end_date: today,
        stats: [],
    });
    
    const [editCompany, setEditCompany] = useState([]);

    const handleSubmit = async (event) => {
        onSubmit(options);
    };

    const handleCheckboxChangeStat = (event) => {
        const {name, checked} = event.target;
        let stats = [...options.stats];

        if (checked) {
            stats.push(name);
        } else {
            stats = stats.filter((satat) => satat !== name);
        }

        setOptions({...options, stats});
    };

    const [selectedRange, setSelectedRange] = useState({
        startDate: new Date(options.start_date),
        endDate: new Date(options.start_date),
        key: 'selection',
    });

    const handleDateChange = (event) => {
        const endDate = new Date(event.endDate);
        endDate.setHours(12, 12, 12, 12);
        const endDateISOString = endDate.toISOString().split('T')[0];

        const startDate = new Date(event.startDate);
        startDate.setHours(12, 12, 12, 12);
        const startDateISOString = startDate.toISOString().split('T')[0];

        setSelectedRange((prevSelectedRange) => ({
            ...prevSelectedRange,
            startDate: new Date(startDateISOString),
            endDate: new Date(endDateISOString),
            key: 'selection',
        }));

        if (endDate && startDate) {
            setOptions((prevOptions) => ({
                ...prevOptions,
                start_date: startDateISOString,
                end_date: endDateISOString,
            }));
        }
    };

    const handleOpenEditBundle = () => {
        setOpenEditBundle(true);
    };

    const handleCloseEditBundle = () => {
        setOpenEditBundle(false);
    };

    return (
        <Grid container spacing={2} sx={{ width: "100%", marginLeft: '0px', }}>
            <Accordion sx={{width: "100%"}}>
                <AccordionSummary
                    expandIcon={<KeyboardDoubleArrowDownOutlinedIcon/>}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    sx={{backgroundColor: '#f0f3f5', width: "100%"}}
                >
                    Options
                </AccordionSummary>
                <AccordionDetails sx={{width: "100%"}}>
                    <Grid item xs={12} md={12} sx={{width: "100%"}}>
                        <form>
                            <Grid item xs={12} md={12} sx={{width: "100%", margin: '0px 0 25px auto'}}>
                                <Grid item xs={12} md={12}>
                                    {Object.keys(statistics).length != 0 ? (<strong>Data</strong>) : ''}
                                </Grid>
                                {statistics?.map((statistic) => (
                                    <StatisticsCheckbox
                                        key={statistic.key}
                                        statistic={statistic}
                                        checked={options.stats.includes(statistic.key)}
                                        onChange={handleCheckboxChangeStat}
                                    />
                                ))}
                            </Grid>
                        </form>
                    </Grid>
                </AccordionDetails>
            </Accordion>
            <Grid item xs={6} md={6}>
                <Button
                    size={"large"}
                    startIcon={<BackupTableOutlinedIcon fontSize="small"  />}
                    onClick={handleSubmit}
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{ marginLeft: '-15px', marginBottom: '15px' }}
                >
                    Generate Report
                </Button>

                <Button
                    size="large"
                    startIcon={<PlaylistAddIcon fontSize="small" />}
                    onClick={handleOpenEditBundle}
                    variant="contained"
                    color="success"
                    sx={{ marginLeft: '15px', marginBottom: '15px' }}
                >
                    Create
                </Button>

                <Button
                    size={"large"}
                    startIcon={<UploadFileOutlinedIcon/>}
                    onClick={handleClickOpenUpload}
                    type="submit"
                    variant="outlined"
                    sx={{ marginLeft: '15px', marginBottom: '15px' }}
                >
                    Upload CSV
                </Button>
            </Grid>
            {loading &&
                <Grid item xs={12} md={12}>
                    <Box justifyContent="center" textAlign={"center"} alignItems="center">
                        <CircularProgress size={200}/>
                    </Box>
                </Grid>}

            <Grid item xs={6} md={6}>
                <DateRangeSelector
                    initialRange={{ startDate: twoWeeksAgo, endDate: today, key: 'selection' }}
                    onRangeChange={handleDateChange}
                />
            </Grid>

            <CreateInsertBundleDialog
                open={openEditBundle}
                handleClose={handleCloseEditBundle}
                onSuccess={handleSubmit}
                adtCompany={adtCompanies}
            />

            <UploadFileDialog
                open={openUpload}
                handleClose={handleCloseUpload}
                templateLink={templateLink}
                onSuccess={handleSubmit}
            />
        </Grid>
    );
}

export default InsertBundlesPanelOptions;
